import { render, staticRenderFns } from "./onlineDebug.vue?vue&type=template&id=00d170a8&scoped=true"
import script from "./onlineDebug.vue?vue&type=script&lang=js"
export * from "./onlineDebug.vue?vue&type=script&lang=js"
import style0 from "./onlineDebug.vue?vue&type=style&index=0&id=00d170a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d170a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d170a8')) {
      api.createRecord('00d170a8', component.options)
    } else {
      api.reload('00d170a8', component.options)
    }
    module.hot.accept("./onlineDebug.vue?vue&type=template&id=00d170a8&scoped=true", function () {
      api.rerender('00d170a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openPlatform/onlineDebug.vue"
export default component.exports